module.exports = __webpack_public_path__ + "static/media/worship_important.3686f6d1.svg";